import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { Roles } from "data/@types/Amplify";
import { useAuthStore } from "data/store/Auth";

type ProtectedRouteProps = {
  allowedRoles: Roles[];
};

const ProtectedRoute = ({ allowedRoles }: ProtectedRouteProps) => {
  const { roles, loading: isLoadingRoles } = useAuthStore();
  const location = useLocation();

  const hasAccess = roles.some((role) => allowedRoles.includes(role));

  if (!hasAccess && !isLoadingRoles) {
    return <Navigate to="/home" replace state={{ from: location }} />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
